import React, {ReactElement, ReactNode, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {useService} from '@yosmanyga/di';
import {Markdown} from '@yosmanyga/rich-ui';
import {HelpController} from '../../controller';

const Help = observer(({templates}: HelpProps) => {
    const controller = useService(HelpController, []);

    useEffect(() => {
        (async () => {
            await controller.load();
        })();
    }, []);

    const TextsComponent = observer(() => {
        if (!controller.loaded) {
            return null;
        }

        return <>
            <Markdown
            >
                {controller.texts.cheatsheet}
            </Markdown>

            <Markdown
                margin={{
                    top: 4
                }}
            >
                {controller.texts.intro}
            </Markdown>

            <Markdown
                margin={{
                    top: 4
                }}
            >
                {controller.texts.gameplay}
            </Markdown>

            <Markdown
                margin={{
                    top: 4
                }}
            >
                {controller.texts.credits}
            </Markdown>
        </>
    })

    return <templates.layout
        texts={<TextsComponent/>}
    />
});

type HelpProps = {
    templates: {
        layout: (
            params: {
                texts?: ReactElement;
            }
        ) => ReactNode;
    };
};

export type {
    HelpProps
}

export {
    Help
};
